import React from 'react';
import { withTheme } from '@material-ui/core/styles';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import CustomerSignup from '../../components/Customer/CustomerSignup';
import ProviderSignup from '../../components/Customer/ProviderSignup';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import SocialSignin from '../../components/Social/SocialSignin';
import AppLinks from '../../components/About/AppLinks';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Radio } from '@material-ui/core';


const styles = theme => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper
    },
    bigIndicator: {
        height: 0
    }
});
function TabContainer(props) {
    return <Typography component="div">{props.children}</Typography>;
}

class SignupForm extends React.Component {
    // constructor(props) {
    //     super(props);
    //     console.log("Sign up props", props)

    //     const becomeProvider = 
    //     this.props.location && 
    //     this.props.location.state && 
    //     this.props.location.state.becomeProvider 
    //     ? this.props.location.state.becomeProvider 
    //     : false;

    //     console.log("becomeProvider",becomeProvider);

    //     this.state = {
    //         loaderButton: false,
    //         email: '',
    //         password: '',
    //         value: becomeProvider ? 1 : 0,
    //     };
    //     console.log("value", this.state.value);
    // }


    constructor(props) {
        super(props);
        console.log("Sign up props", props);
    
        const becomeProvider = 
            (this.props.location && 
            this.props.location.state && 
            this.props.location.state.becomeProvider) || false;
    
        console.log("becomeProvider", becomeProvider);
    
        this.state = {
            loaderButton: false,
            email: '',
            password: '',
            value: becomeProvider ? 1 : 0,
        };
        console.log("value", this.state.value);
    }
    
    componentDidMount() {
        this.props.removeHeaderAction(false);
    }
    componentWillUnmount() {
        this.props.removeHeaderAction(false);
    }



    handleClose = () => {
        this.props.closeLoginPopup();
    };
    handleChange = (event, value) => {
        this.setState({ value });
    };
    renderLoginPage = () => {
        this.props.history.push('/user/signin', {
            booking_data: {},
            taskData: [],
            loginPath: 'Signup'
        });
    };


    render() {
        const { value } = this.state;
        const { formatMessage } = this.props.intl;

        return (
            <div>
                <div className="inn-page-bg">
                    <div className="container">
                        <div className="row">
                            <div className="inn-pag-ban_div">
                            </div>
                            <div className="inn-pag-ban_div2">
                            </div>
                            <div className="inn-pag-ban">
                                <h2><span> {
                                    this.props.location.message
                                }
                                </span></h2>
                                <hr className="line">
                                </hr>
                                <p class="refer_class">{
                                    this.props.location.message2
                                }
                                </p>
                            </div>
                            <div class="icon_down"></div>
                        </div>
                    </div>
                </div>
                <div className="tz-register">
                    <div className="log-in-pop">
                        <div className="log-in-pop-right">
                            <a
                                href="#"
                                className="pop-close"
                                data-dismiss="modal"
                            />
                            <h4>Create an Account</h4>
                            <p>
                                Create your account. It's
                                a quick process!
                            </p>
                            <div className="s12 ng-pristine ng-valid">
                                <div>
                                    <AppBar
                                        position="static"
                                        color="default"
                                        className="create-account-nav"
                                    >
                                        <Tabs
                                            value={value}
                                            onChange={this.handleChange}
                                            variant="scrollable"
                                            scrollButtons="on"
                                            indicatorColor="primary"
                                            textColor="primary"
                                            centered
                                        >
                                            <Tab
                                                className="btn-tab-account"
                                                label={formatMessage({
                                                    id: 'customer'
                                                })}
                                            />
                                            <Tab
                                                className="btn-tab-account"
                                                label={formatMessage({
                                                    id: 'Provider'
                                                })}
                                            />
                                        </Tabs>
                                    </AppBar>
                                    {value === 0 && (
                                        <TabContainer>
                                            <CustomerSignup />
                                        </TabContainer>
                                    )}
                                    {value === 1 && (
                                        <TabContainer>
                                            <ProviderSignup />
                                        </TabContainer>
                                    )}
                                </div>
                                
                                <div>
                                    {/* <p style={{ fontWeight: "500", margin: '10px 0' }} >
                                        I agree to receive text messages from eZpro (+1 8885215854)
                                    </p> */}
                                    <div className="input-field s12">
                                        <a
                                       
                                        href="javascript:void(0);">
                                            Are you already a member?
                                            <p style={{ color: "#0077fd", fontWeight: "600", paddingLeft:"10px" }} onClick={this.renderLoginPage}>
                                                Login
                                            </p>
                                        </a>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>

                <AppLinks settings={this.props.settings} />

            </div>
        );
    }
}
const mapStateToProps = ({ settings }) => {
    return { settings };
};
const composedHOC = compose(
    withTheme(),
    withStyles(styles),
    connect(mapStateToProps, actions)
);
export default composedHOC(withRouter(injectIntl(SignupForm)));



// WEBPACK FOOTER //
// ./src/views/Signup/SignupForm.jsx